import React from 'react';
import { Text, View } from 'react-native';
import i18n from 'i18n-js';

import { scale } from '@components/frame';
import { font } from '@styles/fonts';

import { GOAL_OPTIONS } from '@components/tenantStatus/onboardingWizard/constants';
import { isOtherSelected } from '@components/tenantStatus/onboardingWizard/helpers';
import type { GoalsStepProps } from '@components/tenantStatus/onboardingWizard/types';
import ChipGroup from '@components/tenantStatus/onboardingWizard/components/ChipGroup';
import WizardInput from '@components/tenantStatus/onboardingWizard/components/WizardInput';

const GoalsStep = ({ C, data, onChange }: GoalsStepProps) => {
  const otherSelected = isOtherSelected(data.selectedGoals);

  return (
    <View>
      <Text style={[font['Title 2'], { color: C('Label/Light/Primary'), marginBottom: scale(20) }]}>
        {i18n.t('Your Goals')}
      </Text>

      <Text style={[font['Subhead 1'], { color: C('Label/Light/Primary') }]}>
        {i18n.t('What do you want to achieve with Smart Factory?')}
      </Text>
      <Text style={[font['Footnote'], { color: C('Label/Light/Tertiary'), marginBottom: scale(8) }]}>
        {i18n.t('Optional — select all that apply')}
      </Text>
      <ChipGroup
        C={C}
        options={GOAL_OPTIONS}
        selected={data.selectedGoals}
        multiSelect
        onChange={(selectedGoals) => onChange({ ...data, selectedGoals })}
        testIDPrefix="onboarding-wizard-goals-chip"
      />

      {otherSelected && (
        <>
          <Text style={[font['Subhead 1'], { color: C('Label/Light/Primary'), marginTop: scale(16), marginBottom: scale(8) }]}>
            {i18n.t('Tell us more')}
          </Text>
          <WizardInput
            C={C}
            value={data.tellUsMore}
            onChangeText={(tellUsMore: string) => onChange({ ...data, tellUsMore })}
            placeholder={i18n.t('Describe your goals...')}
            multiline
            maxLength={200}
            testID="onboarding-wizard-goals-textarea"
          />
        </>
      )}
    </View>
  );
};

export default GoalsStep;
